import styled from "@emotion/native";
import { ViewStyle, ImageStyle } from "react-native";

import { SafeModeIcon as SafeTeeIcon } from "myplan/components/Icon";

export const CONTAINER_WIDTH = 55;
export const ICON_WIDTH = 30;

export const Container = styled.TouchableOpacity(
	{
		width: CONTAINER_WIDTH,
		height: CONTAINER_WIDTH,
		borderRadius: 55,
		alignSelf: "center",
		alignContent: "center",
		justifyContent: "center",
		alignItems: "center",
	},
	({ theme }: any) => {
		let style: ViewStyle = {
			backgroundColor: theme.color.accent,
		};

		if (theme.verticalScale < 1) {
			const delta = (1 - theme.verticalScale) / 2;
			const verticalScale = 1 - delta;
			const width = CONTAINER_WIDTH * verticalScale;
			const height = width;
			const borderRadius = width;

			return {
				...style,
				width,
				height,
				borderRadius,
			};
		}

		return style;
	}
);

export const SafeModeIcon = styled(SafeTeeIcon)(
	{
		height: ICON_WIDTH,
		width: ICON_WIDTH,
	},
	({ theme }: any) => {
		let style: ImageStyle = {};

		if (theme.verticalScale < 1) {
			const delta = (1 - theme.verticalScale) / 2;
			const verticalScale = 1 - delta;
			const width = ICON_WIDTH * verticalScale;
			const height = width;

			style = {
				width,
				height,
			};
		}

		return style;
	}
);

export const Icon = styled.Image(
	{
		height: 55,
		width: 55,
	},
	({ theme }: any) => {
		let style: ImageStyle = {};

		if (theme.verticalScale < 1) {
			const delta = (1 - theme.verticalScale) / 2;
			const verticalScale = 1 - delta;
			const width = CONTAINER_WIDTH * verticalScale;
			const height = width;

			style = {
				width,
				height,
			};
		}

		return style;
	}
);
